import { queryClient } from 'index';
import { useTranslation } from 'react-i18next';
import { useMutation, useQuery } from 'react-query';
import { toast } from 'react-toastify';
import { getToastErrorMessage, LogyxError } from 'services/api/errors';
import { ReactMutationKeys } from 'services/api/reactMutationKeys';
import { ReactQueryKeys } from 'services/api/reactQueryKeys';
import { editBuyer, getSingleBuyer } from 'services/CompanyService';

export const useGetSingleBuyer = (buyerId: number) =>
  useQuery({
    queryKey: [ReactQueryKeys.GET_SINGLE_BUYER, buyerId],
    queryFn: () => {
      return getSingleBuyer(Number(buyerId));
    },
    enabled: !!buyerId,
  });

export interface IEditBuyerDTO {
  id: number;
  isActive: boolean;
}

export const useEditBuyer = () => {
  const { t } = useTranslation();
  return useMutation((dto: IEditBuyerDTO) => editBuyer(dto), {
    onSuccess: () => {
      toast.success(t('Buyer updated'));
      queryClient.invalidateQueries([ReactQueryKeys.GET_SINGLE_BUYER]);
    },
    onError: (error: LogyxError) => {
      toast.error(getToastErrorMessage(error));
    },
    mutationKey: ReactMutationKeys.EDIT_BUYER,
  });
};
